var TorsoView = require('backbone-torso/modules/View');
var eregAuthMethodConfigPerspectiveTemplate = require('./eregAuthMethodConfigPerspectiveTemplate.hbs');
var EregAuthMethodConfigView = require('./EregAuthMethodConfigView');

/**
 * Perspective to display the barcode authentication workflow for tablets
 *
 * @class EregAuthMethodConfigPerspective
 * @constructor
 */
var EregAuthMethodConfigPerspective = TorsoView.extend({
  className: 'brec-authentication portal-authentication--portal',
  moduleNamespace: 'eregAuthMethodConfigPerspective',
  template: eregAuthMethodConfigPerspectiveTemplate,

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    this._authView = new EregAuthMethodConfigView();

  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('main', this._authView);
  }
});

module.exports = EregAuthMethodConfigPerspective;
